import { connect } from 'react-redux';
import BarPlot from '../../components/Nuclei/BarPlot';

const mapStateToProps = state => ({
  cellPopulation: state.cellPopulation,
});

export default connect(mapStateToProps)(BarPlot);



// WEBPACK FOOTER //
// ./src/containers/Nuclei/BarPlot.jsx